import { useQuery } from "react-query";
import axios from "axios";
import { toast } from "react-toastify";
import { SelectionListItem } from "../Forms/SelectionListItem";
import { minutesAsMilliSeconds } from "../Utils/time";
import { ExtractAllowed } from "../Utils/utilityTypes";
import { QueryKeyName } from "../ReactQuery/namedQueryKeyWithId";

type GeoLocationSelectionItemsQueryKeyName =
  | "sprHandlingTime"
  | "supplierHandlingTime"
  | "bidPackOriginRegion";

type GeoLocationSelectionItemsQueryKeySubName = ExtractAllowed<
  QueryKeyName,
  "edcs" | "odcs" | "plants" | "suppliers"
>;

type ErrorMessageProps = "Supplier" | "Plant";

export const geoLocationSelectionItemsQueryKey = (
  queryKey: GeoLocationSelectionItemsQueryKeyName,
  queryKeySubName: GeoLocationSelectionItemsQueryKeySubName,
  id: number
) => [queryKey, queryKeySubName, id];

type FetchProps<T> = {
  apiUrl: string;
  selectedItems: T[];
  errorMessage: ErrorMessageProps;
  queryKeyName: GeoLocationSelectionItemsQueryKeyName;
  queryKeySubName: GeoLocationSelectionItemsQueryKeySubName;
  id: number;
};

export const useFetchGeoLocationSelectionItems = <T>({
  apiUrl,
  selectedItems,
  errorMessage,
  queryKeyName,
  queryKeySubName,
  id,
}: FetchProps<T>) => {
  return useQuery<SelectionListItem<string>[], Error>({
    queryKey: geoLocationSelectionItemsQueryKey(queryKeyName, queryKeySubName, id),
    staleTime: minutesAsMilliSeconds(10),
    cacheTime: minutesAsMilliSeconds(20),
    queryFn: () => fetchGeoLocationSelectionItems(apiUrl, selectedItems),
    onError: () => {
      toast.error(`An error occurred when retrieving the ${errorMessage} GSDBs`);
    },
  });
};

const fetchGeoLocationSelectionItems = async <T>(apiUrl: string, selectedItems: T[]) => {
  const { data: geoLocationSelectionItems } = await axios.post<SelectionListItem<string>[]>(
    apiUrl,
    selectedItems
  );

  return geoLocationSelectionItems;
};
